module.exports = __webpack_public_path__ + "static/media/rsna18-group-3.a088e3a8.svg";